import {gsap} from 'gsap';

( function( app ) {
  const COMPONENT = {
    init: function() {
      gsap.utils.toArray( '[data-component="left-right"]' ).forEach( function( $componentEl ) {
        gsap.utils.toArray( $componentEl.querySelectorAll( '.js-image-wrapper' ) ).forEach( function( $imageWrapper ) {
          const $image = $imageWrapper.querySelector( '.js-image' );
          gsap.to( $image, {
            y: () => $image.offsetHeight - $imageWrapper.offsetHeight,
            ease: 'none',
            scrollTrigger: {
              trigger: $componentEl,
              scrub: true,
              pin: false,
              invalidateOnRefresh: true,
            },
          } );
        } );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'left-right', COMPONENT );
} )( app );
